module.exports = __webpack_public_path__ + "static/media/MileMarkerDinner.6fdec30b.pdf";